import { render, staticRenderFns } from "./FacilitiesToAddPostDialog.vue?vue&type=template&id=3079dd0a&scoped=true&"
import script from "./FacilitiesToAddPostDialog.vue?vue&type=script&lang=js&"
export * from "./FacilitiesToAddPostDialog.vue?vue&type=script&lang=js&"
import style0 from "./FacilitiesToAddPostDialog.vue?vue&type=style&index=0&id=3079dd0a&lang=scss&scoped=true&"
import style1 from "./FacilitiesToAddPostDialog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3079dd0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VVirtualScroll } from 'vuetify/lib/components/VVirtualScroll';
installComponents(component, {VCol,VListItem,VListItemContent,VRow,VTextField,VVirtualScroll})
